/**
 * Formats inventory number in the exact required format:
 * INV-SI-DD-MM-YYYY-0001
 *
 * @param {Object} item - Inventory object
 * @param {number} [count] - Inventory count / sequence number
 * @returns {string} Formatted inventory number
 */
export const formatInventoryNumber = (item, count) => {
  if (!item) {
    return '';
  }

  if (item.inventoryNumber) {
    return item.inventoryNumber;
  }
  if (item.inventoryNo) {
    return item.inventoryNo;
  }
  if (item.inventoryCode) {
    return item.inventoryCode;
  }

  const createdDate = item.createdOn ? new Date(item.createdOn) : new Date();
  const inventoryCount = item.inventoryCount ?? count ?? 1;
  const formattedCount = String(inventoryCount).padStart(4, '0');

  const day = String(createdDate.getDate()).padStart(2, '0');
  const month = String(createdDate.getMonth() + 1).padStart(2, '0');
  const year = createdDate.getFullYear();
  const formattedDate = `${day}-${month}-${year}`;

  return `INV-SI-${formattedDate}-${formattedCount}`;
};
